<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.path !== '/validateNewPhoto' && $route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />

    <transition name="fade-in">
      <div class="dialog-ctr" v-if="showNeedBind">
        <div class="dialog">
          <div class="dialog-info">
            <span class="dialog-sole">您还没有绑定支付宝账号或银行卡哦，绑定后再进行操作</span>
          </div>
          <div class="dialog-operate">
            <div class="dialog-btn" @click="cancelBindAll">暂不绑定</div>
            <div class="dialog-btn" @click="goBindAll">去绑定</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Bus from "@/assets/js/bus";
import { setDocTitle, logoutB } from '@/utils/birdge'
import { isInNewJsBridgeApp, isInApp, isInAppB } from '@/utils'
import {setToken} from '@/utils/token'

export default {
  name: "App",
  data() {
    return {
      include: ['RiskAduitDetail']
    }
  },
  created() {
    let autoToken = this.getQueryString('token') || '';
    let merchantNo = this.getQueryString('merchantNo') || '';
    console.log('h5页面', decodeURIComponent(autoToken))
    if(autoToken) {
      setToken(decodeURIComponent(autoToken));
      this.$store.commit('SET_LOG_IN_STATIC', true)
    } 
    if(merchantNo){
      this.$store.commit("SET_MERCHANT_NO", merchantNo);
    }
    //获取初始值
    Bus.$on("initData", callback => {
      //获取用户信息
      let p1 = () => {
        return new Promise((resolve, reject) => {
          this.checkLogin(
            res => {
              resolve();
            },
            () => {
              reject();
            }
          );
        });
      };
      return Promise.all([p1()])
        .then(() => {
          callback && callback();
        })
        .catch(() => {
          callback && callback();
        });
    });
    Bus.$on("outData", callback => {
      //退出登录
      // 判断是否在 C 端
      const webViewClientC = window.navigator.userAgent.indexOf("hxAx_C") > -1;
    console.log(webViewClientC, '是否是C端');
      let p2 = () => {
        return new Promise((resolve, reject) => {
          if (webViewClientC) {
            this.loginOut(
              res => { resolve(); },
              () => { reject(); }
            );
          } else {
            // B端退出登录
            logoutB()
          }
        });
      };
      return Promise.all([p2()])
        .then(() => {
          callback && callback();
        })
        .catch(() => {
          callback && callback();
        });
    });
  },
  mounted() {
    document.body.addEventListener("touchmove", () => {});
    this.checkLogin();

    // 友盟统计添加
    const script = document.createElement('script')
    script.src =
      'https://s4.cnzz.com/z_stat.php?id=1279989086&web_id=1279989086' //该路径为点击统计代码后，页面中第一个 文字统计 script代码
    script.language = 'JavaScript'
    document.body.appendChild(script)
    // 上报是否是新老版dsbridge
    const timeId = setTimeout(() => {
      window._czc &&
        window._czc.push(['_setCustomVar', "是否新版本 dsbridge", isInNewJsBridgeApp() ? "1": "0"])
      if(isInApp()) {
        const curAppVersion = window.navigator.userAgent.match(/HxAxClientCmWebKit\/(\S*)/)[1];
        window._czc &&
          window._czc.push(['_setCustomVar', "app 版本", curAppVersion]);
        window._czc &&
          window._czc.push(['_setCustomVar', "B 端", isInAppB() ? "1" : "0" ]);
      } else {
        window._czc &&
          window._czc.push(['_setCustomVar', "app 版本", "0.0.00"]);
      }
      clearTimeout(timeId)
    }, 1500)
  },
  methods: {
    showBindAll() {
      // debugger
      this.showGoBind = true;
      this.setTencent("dialog_total");
    },
    goBindAll() {
      this.$store.commit("SET_SHOW_NEED_BIND", false);
      this.setTencent("total_bind");
      this.$router.push("bindAll");
    },
    cancelBindAll() {
      this.$store.commit("SET_SHOW_NEED_BIND", false);
      this.setTencent("total_cancel");
    }
  },
  computed: {
    isLogIn() {
      return this.$store.state.isLogIn;
    },
    showNeedBind() {
      return this.$store.state.showNeedBind;
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.title) {
        setDocTitle({
          title: to.meta.title
        })
        document.title = to.meta.title;
      }
      if (!this.isLogIn) {
        this.checkLogin();
      }
      window._czc &&
        window._czc.push(['_trackPageview', to.fullPath, from.fullPath])
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

#app {
  max-width: 7.5rem;
  margin: 0 auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

.out-of-wx {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  padding-top: 3rem;
  text-align: center;

  img {
    margin-bottom: 0.2rem;
    width: 1.08rem;
  }

  div {
    font-size: 0.36rem;
    color: #1a1a1a;
  }
}

@font-face {
  font-family: "digit";
  src: url("https://cdn.julanling.com/h5/fonts/DIN_Alternate_Bold.ttf");
}

.add-underline {
  text-decoration: underline;
}

.digit {
  font-family: digit;
}

.total-info-ctr {
  background: #fff;
  padding: 0.3rem;

  .total-info-bg {
    padding: 0.48rem;
    height: 2.76rem;
    border-radius: 0.12rem;
    background: linear-gradient(
      270deg,
      rgba(47, 106, 226, 1) 0%,
      rgba(33, 127, 242, 1) 49%,
      rgba(21, 146, 255, 1) 100%
    );
    box-shadow: 0 0.1rem 0.16rem 0 rgba(11, 100, 228, 0.3);
  }

  .name-title {
    color: #fff;
    font-size: 0.28rem;
  }

  .money-content {
    color: #fff;
    font-size: 0.8rem;
  }

  .money-tips {
    font-size: 0.24rem;
    color: #fff;
  }
}

/*输入确认通用*/
.confirm-btn {
  position: relative;
  margin-top: 0.72rem;
  line-height: 1.08rem;
  border-radius: 0.08rem;
  background: linear-gradient(to right, #bbb 0, #bbb 50%, #dfdfdf 100%);
  text-align: center;
  font-size: 0.32rem;
  color: #fff;

  &.blue-bg {
    background: rgba(63, 143, 255, 0.5);
  }

  &.active {
    background: #3f8fff;

    &:active {
      opacity: 0.9;
    }
  }

  .warn {
    position: absolute;
    display: flex;
    align-items: center;
    top: -0.44rem;
    line-height: 1;
    font-size: 0.24rem;
    color: #999999;

    img {
      margin-right: 0.12rem;
      width: 0.24rem;
    }
  }
}

/*弹框通用*/
.dialog-ctr {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;

  .dialog {
    width: 5.9rem;
    border-radius: 0.12rem;
    background: #fff;

    .dialog-title {
      font-weight: 700;
      font-size: 0.4rem;
      color: #333;
    }

    &-info {
      color: #333333;
      padding: 0.5rem 0.4rem;
      text-align: center;

      span {
        font-size: 0.32rem;
        display: inline-block;
        margin-top: 0.44rem;
      }

      span.dialog-title {
        margin-top: 0;
        font-size: 0.4rem;
      }

      span.dialog-sole {
        margin-top: 0;
        font-size: 0.36rem;
        line-height: 0.5rem;
      }
    }

    &-operate {
      display: flex;
      justify-content: center;
      width: 100%;
      border-top: 0.02rem solid #eee;
    }

    &-btn {
      flex: 1;
      line-height: 1rem;
      /*font-weight: 600;*/
      text-align: center;
      font-size: 0.34rem;
      color: #666666;

      &:nth-of-type(2) {
        border-left: 0.02rem solid #eee;
      }

      &:last-of-type {
        color: #3f8fff;
      }

      &:active {
        opacity: 0.8;
      }
    }
  }

  .confirm-dialog {
    width: 5.86rem;
    height: auto;
    text-align: center;
    font-size: 0.36rem;
    color: #333333;

    span {
      font-size: 0.48rem;
      color: #1b65ff;
    }
  }
}

/*数据加载*/
.load-more {
  line-height: 0.8rem;
  text-align: center;

  img {
    width: 0.48rem;
  }

  span {
    font-size: 0.28rem;
    color: #444;
  }
}

.slide-in-enter-to,
.slide-in-leave {
  transform: translate3d(0, 0, 0);
}

.slide-in-enter,
.slide-in-leave-to {
  transform: translate3d(0, 100%, 0);
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: all 300ms cubic-bezier(0.55, 0, 0.1, 1);
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}

.empty {
  img {
    width: 2.3rem;
    height: 2.3rem;
    display: block;
    margin: 2.6rem auto 0.74rem;
  }

  .intro {
    width: 3.52rem;
    height: 0.76rem;
    font-size: 0.32rem;
    font-weight: 400;
    line-height: 0.44rem;
    color: #999999;
    margin: auto;
  }
}
</style>
